import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  newSectionButton: {
    id: 'course-authoring.course-outline.header-navigations.button.new-section',
    defaultMessage: 'New section',
  },
  addButton: {
    id: 'course-authoring.course-outline.header-navigations.button.add-button',
    defaultMessage: 'Add',
    description: 'Add button text in course outline header',
  },
  newSectionButtonTooltip: {
    id: 'course-authoring.course-outline.header-navigations.button.new-section.tooltip',
    defaultMessage: 'Click to add a new section',
  },
  reindexButton: {
    id: 'course-authoring.course-outline.header-navigations.button.reindex',
    defaultMessage: 'Reindex',
  },
  reindexButtonTooltip: {
    id: 'course-authoring.course-outline.header-navigations.button.reindex.tooltip',
    defaultMessage: 'Reindex current course',
  },
  expandAllButton: {
    id: 'course-authoring.course-outline.header-navigations.button.expand-all',
    defaultMessage: 'Expand all',
  },
  collapseAllButton: {
    id: 'course-authoring.course-outline.header-navigations.button.collapse-all',
    defaultMessage: 'Collapse all',
  },
  viewLiveButton: {
    id: 'course-authoring.course-outline.header-navigations.button.view-live',
    defaultMessage: 'View live',
  },
  courseInfoButtonTooltip: {
    id: 'course-authoring.course-outline.header-navigations.button.course.info.tooltip',
    defaultMessage: 'Click to open course info in sidebar',
    description: 'Tooltip text of course info button',
  },
  courseInfoButton: {
    id: 'course-authoring.course-outline.header-navigations.button.course.info',
    defaultMessage: 'Course info',
    description: 'Course info button in course outline header',
  },
  viewLiveButtonTooltip: {
    id: 'course-authoring.course-outline.header-navigations.button.view-live.tooltip',
    defaultMessage: 'Click to open the courseware in the LMS in a new tab',
    description: 'Tooltip text of view live button',
  },
});

export default messages;
